<div id="main-container">

    <div class="header">

        <div class="container-image">
            <img src="/assets/imagenes/icons/UP-11.svg" class="logo">
        </div>

        <div class="container-title">
            <div class="container-icon-and-title">
                <mat-icon>help</mat-icon>
                <h1>{{ 'preguntas_frecuentes' | translate }}</h1>
            </div>
            <div class="container-button-enter">
                <button 
                    mat-flat-button 
                    color="accent"
                    [routerLink]="['/']">
                    {{ (userIsLogged ? 'volver-a-inicio' : 'ingresar') | translate | titlecase }}
                    <mat-icon color="primary">home</mat-icon>
                </button>
            </div>
        </div>

    </div>

    <div class="content">

        <div class="questions">
            <h3>{{ 'solicitar_eliminacion_cuenta' | translate }}</h3>
            <p>
                Debes escribirnos un correo a: 
                <small class="tag-email" (click)="redirecTo( 'https://mail.google.com/mail/?view=cm&fs=1&su=Eliminación de cuenta&tf=1&to=solicitud.usuarios@airissoluciones.es' )">
                    {{ 'info@sol-fix.com' }}
                </small>, colocando como asunto "Eliminación de cuenta", además debes proporcionarnos los siguientes datos: 
                <br/>
                <strong>1.</strong> Tu nombre completo. <br/>
                <strong>2.</strong> Tu nombre de usuario en la aplicación. <br/>
                <strong>3.</strong> Una cuenta de correo válida. <br/>
                Con estos datos realizaremos la adecuada validación de la información enviada. <br/>
                De antemano te informamos que contamos con dos opciones para "Eliminar tu cuenta":
                <br/>
                <strong>1.</strong> Desactivando tu cuenta: Tus datos no se removerán, por el contrario se ocultarán, 
                cuando desees puedes activarla nuevamente (Esta es la opción que recomendamos).
                <br/>
                <strong>2.</strong> Eliminando completamente tus datos de nuestros servidores: Tus datos se removerán completamente de nuestro servicio y 
                no será posible recuperarlos.
                <br/>
                <br/>
                En un plazo máximo de cinco (5) días nos contactaremos mediante el correo electrónico ingresado.  
            </p>
            <mat-divider></mat-divider>
            <h3>{{ 'donde-politicas-privacidad' | translate }}</h3>
            <p>
                Para leer nuestra politica de privacidad puede acceder a <a class="tag-email" target="_blank" href="https://solfixsmartcity.com/politica-de-privacidad/">Este enlace</a>. <br/>
            </p>
            <mat-divider></mat-divider>
            <h3>{{ 'donde_leer_politica_de_cookies' | translate }}</h3>
            <p>
                Para leer nuestra politica de cookies puede acceder a <a class="tag-email" target="_blank" href="https://solfixsmartcity.com/politica-de-cookies/">Este enlace</a>. <br/>
            </p>
            <mat-divider></mat-divider>
            <h3>{{ 'aviso_legal' | translate }}</h3>
            <p>
                Para leer nuestro aviso legal puedes acceder a <a class="tag-email" target="_blank" href="https://solfixsmartcity.com/aviso-legal/">Este enlace</a>. <br/>
            </p>
            <mat-divider></mat-divider>
        </div>
    </div>

</div>
